import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useSubscriptionAccess } from '@/hooks/useSubscriptionAccess';
import T from '@/components/T';
import subscriptionTranslations from '@/i18n/locales/components/subscription';

export const SubscriptionExpiredBanner = () => {
  const { isExpired, isAdmin, loading } = useSubscriptionAccess();

  // Don't show banner if still loading or subscription is not expired
  if (loading || !isExpired || !isAdmin) {
    return null;
  }

  return (
    <Alert className="border-destructive bg-destructive/10 mb-4">
      <AlertTriangle className="h-4 w-4 text-destructive" />
      <AlertDescription className="text-destructive font-medium">
        <T ru={subscriptionTranslations.banner.expired.ru} en={subscriptionTranslations.banner.expired.en} />
      </AlertDescription>
    </Alert>
  );
};